export default __webpack_public_path__ + "static/media/person_2.2ad99269.png";